import React from 'react';
import ReactECharts from 'echarts-for-react';

import { DonutChartProps } from 'types/e-charts';

const DonutChart: React.FC<DonutChartProps> = ({
  series,
  labels,
  colors,
  width = 257,
  height = 257,
  className = '',
  innerRadius = '50%',
  outerRadius = '90%',
  showTooltip = true,
  showLegend = false,
  showLabels = false,
  tooltipFormatter = '{b}: {c} ({d}%)',
  customOptions = {}
}) => {
  const tooltip = showTooltip
    ? {
        trigger: 'item',
        formatter: tooltipFormatter
      }
    : { show: false };

  const defaultOption = {
    tooltip,
    legend: {
      show: showLegend
    },
    color: colors,
    series: [
      {
        name: '',
        type: 'pie',
        radius: [innerRadius, outerRadius],
        avoidLabelOverlap: false,
        label: {
          show: showLabels
        },
        labelLine: {
          show: showLabels
        },
        data: labels.map((label, i) => ({
          value: series[i].value,
          name: label,
          count: series[i].count
        }))
      }
    ]
  };

  // Merge default options with custom options
  const option = { ...defaultOption, ...customOptions };

  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ width, height }}
    >
      <ReactECharts option={option} style={{ width, height }} />
    </div>
  );
};

export default DonutChart;
